// TOUCH OR NO-TOUCH, THAT IS THE QUESTION!
// SCROLL-TO ANIMATION FOR ANCHOR LINKS
// FADE-IN-UP ELEMENTS ON SCROLL
// SLIDER (SWIPER JS)
// SLIDER (SLICK JS)
// PRODUCT PICKER
// NEWSLETTER PICKER



//
// =TOUCH OR NO-TOUCH, THAT IS THE QUESTION!
// --------------------------------------------------

// function isTouchDevice() {
//   return true == ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
// }
// if (isTouchDevice() === true) {
//   $("body").toggleClass("touch");
// } else {
//   $("body").toggleClass("no-touch");
// }


//
// =SCROLL-TO ANIMATION FOR ANCHOR LINKS
// --------------------------------------------------

// $('.msdw-page-scroll').click(function() {
//   if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
//     var target = $(this.hash);
//     target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
//     if (target.length) {
//       var offsetValue = 0;
//       if ( window.innerWidth <= 767 ) {
//         offsetValue;
//         // console.log(offsetValue);
//       } else {
//         offsetValue = 59;
//         // console.log(offsetValue);
//       }

//       $('html,body').animate({
//         scrollTop: target.offset().top - offsetValue
//       }, 900);
//       return false;
//     }
//   }
// });


//
// =FADE-IN-UP ELEMENTS ON SCROLL
// --------------------------------------------------

// *** IntersectionObserver ***

// const elements = document.querySelectorAll(".msdw-animate");

// function check(entries) {
//   entries.map((entry) => {
//     if (entry.isIntersecting) {
//       entry.target.classList.add("msdw-animated");
//       observer.unobserve(entry.target);
//     }
//   });
// }

// const observer = new IntersectionObserver(check);

// elements.forEach((elem) => observer.observe(elem));


// *** requestAnimationFrame ***

// const scroll = window.requestAnimationFrame;

// function showOnScroll() {
//   const elems = document.querySelectorAll('.msdw-animate');

//   elems.forEach((el) => {
//     const elPosition = el.getBoundingClientRect().top
//     const elScreen = window.innerHeight / .9

//     if (elPosition < elScreen) {
//       el.classList.add('msdw-animated')
//     }
//   });

//   scroll(showOnScroll);
// }

// showOnScroll();


//
// =SLIDER (SWIPER JS)
// --------------------------------------------------



const swiperFreeMode = new Swiper('.swiper-freemode', {
  slidesPerView: 1.11,
  spaceBetween: 10,
  freeMode: {
    enabled: true,
    sticky: true,
  },
  grabCursor: true,
  loop: false,
  breakpoints: {
    600: {
      slidesPerView: 2.5,
      spaceBetween: 15,
    },
    900: {
      slidesPerView: 3.33,
      spaceBetween: 20,
    },
  },
});


//
// =SLIDER (SLICK JS)
// --------------------------------------------------

// $('.msdw-slider-jacket').slick({
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   swipe: false,
//   arrows: false,
//   swipeToSlide: true,   // in case, 2 or more slides at a time
//   autoplay: true,       // if autoplay...
//   accessibility: false  // use this to avoid page jumping bug
// });

// $('.slick-prev').click(function() {
//   $('.msdw-slider-jacket').slick('slickPrev');
// });
//
// $('.slick-next').click(function() {
//   $('.msdw-slider-jacket').slick('slickNext');
// });

// UNSLICK
// If needed, here's a fix for window resizing
// $(window).on('orientationchange resize', function() {
//   $('.msdw-slider-jacket').slick('resize');
// });


//
// =PRODUCT PICKER
// --------------------------------------------------

const productPickers = document.querySelectorAll('.msdw-product-detail-picker');

productPickers.forEach(productPicker => {
  const productIdNumber = productPicker.dataset.productId;
  productPicker.addEventListener('click', (e) => {
    e.preventDefault();
    window.jwsdwMediator.publish('openPicker', 'productDetailPicker', {
      'productId': productIdNumber
    });
  });
});


//
// =NEWSLETTER PICKER
// --------------------------------------------------

// var campaignId = 'familyAndFriends',
//     pickerTag = document.getElementById("openPicker"),
//     newsletterConfig = {},
//     baseUrl = jwsdwSettings.baseUrl;

// $.ajax({
//   type: 'GET',
//   url: baseUrl + '/Newsletter-getNewsletterConfig',
//   data: {
//     campaignId: campaignId
//   },
//   success: function(response) {
//     newsletterConfig = response
//   },
//   error: function(response) {
//     jwsdwApi.popup.showHttpError(response.status)
//   }
// });

// pickerTag.addEventListener("click", function(){
//   window.jwsdwMediator.publish('openPicker', 'newsletterSignupPicker', {
//     "campaign": newsletterConfig.id,
//     "introduction": newsletterConfig.introduction,
//     "disclaimerOne": newsletterConfig.disclaimerOne,
//     "disclaimerTwo": newsletterConfig.disclaimerTwo
//   });
// });


//
// =PLACE SLOT MODULE INSIDE THE LP
// --------------------------------------------------

const sliderSlot = document.getElementById('msdwSlidetSlot');
const catLandingMiddle = document.getElementById('cat-landing-middle');
catLandingMiddle && sliderSlot.appendChild(catLandingMiddle);

const sliderSlot2 = document.getElementById('msdwSlidetSlot2');
const catLandingBottom1 = document.getElementById('cat-landing-bottom1');
catLandingBottom1 && sliderSlot2.appendChild(catLandingBottom1);


//
// =VIDEO MODAL
// --------------------------------------------------

// const playVideoBtns = document.querySelectorAll(".msdw-play-video");
// const msdwPopupVideoWrapper = document.querySelector(
//   ".msdw-popup-video-wrapper"
// );
// const msdwPopupVideoBackDrop = document.querySelector(
//   ".msdw-popup-video-backdrop"
// );
// const msdwPopupVideo = document.getElementById("msdwPopupVideo");

// if (document.contains(msdwPopupVideoWrapper)) {
//   // open
//   playVideoBtns.forEach((playVideoBtn) => {
//     playVideoBtn.addEventListener("click", (e) => {
//       e.preventDefault();
//       const videoUrl = playVideoBtn.href;
//       msdwPopupVideo.setAttribute("src", videoUrl);
//       msdwPopupVideoWrapper.classList.add("msdw-active");
//       document.body.classList.add("jws-overflowHidden");
//       msdwPopupVideo.muted = false;
//       msdwPopupVideo.play();
//     });
//   });

//   // close
//   const closePopUpVideo = () => {
//     document.body.classList.remove("jws-overflowHidden");
//     msdwPopupVideo.muted = true;
//     msdwPopupVideo.pause();
//     msdwPopupVideo.currentTime = 0;

//     msdwPopupVideoWrapper.classList.remove("msdw-active");
//   };

//   msdwPopupVideoBackDrop.addEventListener("click", () => {
//     closePopUpVideo();
//   });

//   window.onkeydown = (e) => {
//     if (e.keyCode == 27) closePopUpVideo();
//   };
// }
